<p-dialog
		[(visible)]="visibleLocal"
		[draggable]="true"
		modal="true"
		(onHide)="fermerModal()"
		styleClass="modale-medium"
		[closable]="true">
	<p-header>
		<span>{{ determinerTitreModale() }} <i [ngClass]="determinerIconSelonType()"></i></span>
	</p-header>

	<div class="alert-recapitulatif-demande-evenement">
		<alert [nom]="ALERTE_DECLARER_EVENEMENT_MODAL"></alert>
	</div>

	<div class="declarer-evenement-modal-container">
		@if (estWeekendPresentDansDatesSelectionnees()) {
			<div class="message-information">
				<p-message severity="warn" text="{{ 'ACCUEIL.DECLARATION_EVENEMENT.POPUP_CONFIRMATION.MESSAGE_PREVENTION_WEEKEND' | translate }}"></p-message>
			</div>
		}
		@if (estTypeAbsence()) {
			<div class="message-information">
				<p-message severity="info" text="{{ 'ACCUEIL.DECLARATION_EVENEMENT.POPUP_CONFIRMATION.MESSAGE_INFORMATION_ABSENCE' | translate }}"></p-message>
			</div>
		}

		@for (dateDemandee of datesDemandees(); track dateDemandee) {
			<div class="panel-date-demandee">
				<p-panel
						[toggleable]="true"
						[collapsed]="true">
					<ng-template pTemplate="header">
						<div class="header">
							<div class="information-demande date">
								<span class="label">{{ 'ACCUEIL.DECLARATION_EVENEMENT.POPUP_CONFIRMATION.DATE' | translate }}</span>
								<span class="valeur">{{ formatterDatePourAffichage(dateDemandee.date) }}</span>
							</div>
							<div class="information-demande duree">
								<span class="label">{{ 'ACCUEIL.DECLARATION_EVENEMENT.POPUP_CONFIRMATION.DUREE' | translate }}</span>
								@if (dateDemandee.estDureeModifiable) {
									<p-dropdown
											[options]="durees()"
											appendTo="body"
											[(ngModel)]="dateDemandee.duree"
											optionLabel="designation"/>
								} @else {
									<span class="valeur">{{ dateDemandee.duree.designation }}</span>
								}
							</div>
						</div>
					</ng-template>
					<ng-template pTemplate="footer">
						<div class="bouton-annuler-declaration">
							<i class="pi pi-trash"
							   (click)="annulerDemandeEvenement(dateDemandee)"
							   pTooltip="{{ 'ACCUEIL.DECLARATION_EVENEMENT.POPUP_CONFIRMATION.BTN_RETIRER' | translate }}"
							></i>
						</div>
					</ng-template>
					<div class="saisi-commentaire">
						<label [ngClass]="classeAlerteTailleCommentaire(dateDemandee.commentaire.length)"
							   for="commentaire">{{ 'ACCUEIL.DECLARATION_EVENEMENT.POPUP_CONFIRMATION.COMMENTAIRE' | translate }} {{ dateDemandee.commentaire.length }} / 255 :</label>
						<textarea
								rows="2"
								cols="30"
								id="commentaire"
								[(ngModel)]="dateDemandee.commentaire"
								pInputTextarea>
			</textarea>
					</div>
				</p-panel>
			</div>
		}
	</div>

	<p-footer>
		<div [hidden]="enregistrementEnCours()">
			<button type="button" pButton
					(click)="creerEvenements()"
					[label]="'GLOBAL.BTN_VALIDER' | translate">
			</button>
			<p-button [label]="'GLOBAL.BTN_ANNULER' | translate" type="button" styleClass="p-button-link" (click)="fermerModal()"></p-button>
		</div>
		@if (enregistrementEnCours()) {
			<span class="app-spinner m-1"></span>
		}
	</p-footer>
</p-dialog>
